"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWHSC = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var globaltime_1 = require("./shared/globaltime");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var zixun_1 = require("./shared/zixun");
var title_bar_1 = require("./shared/title_bar");
var tab2_1 = require("./shared/tab2");
var middle_1 = require("../quotetable/middle");
var title_1 = require("./shared/title");
/**
 *  外汇市场
 */
function PageWHSC() {
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(globaltime_1.GlobalTime, { mt: 10 }),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(LayoutItem, { code: "133.USDCNH", txt: "\u7F8E\u5143\u79BB\u5CB8\u4EBA\u6C11\u5E01" }),
            react_1.default.createElement(LayoutItem, { code: "119.USDTHB", txt: "\u7F8E\u5143\u5151\u6CF0\u94E2" }),
            react_1.default.createElement(LayoutItem, { code: "119.USDAUD", txt: "\u7F8E\u5143\u5151\u6FB3\u5143" }),
            react_1.default.createElement(LayoutItem, { code: "119.USDHKD", txt: "\u7F8E\u5143\u5151\u6E2F\u5E01" })),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(LayoutItem, { code: "100.UDI", txt: "\u7F8E\u5143\u6307\u6570" }),
            react_1.default.createElement(LayoutItem, { code: "119.EURUSD", txt: "\u6B27\u5143\u5151\u7F8E\u5143" }),
            react_1.default.createElement(LayoutItem, { code: "119.GBPUSD", txt: "\u82F1\u9551\u5151\u7F8E\u5143" }),
            react_1.default.createElement(LayoutItem, { code: "119.USDJPY", txt: "\u7F8E\u5143\u5151\u65E5\u5143" })),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 10 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//forex.eastmoney.com/a/cwhdd.html" }, "\u5916\u6C47\u5BFC\u8BFB")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.ColumnNewsScroll, { columns: "764" }))),
        react_1.default.createElement(WH_Tabbox, null),
        react_1.default.createElement(WH_HOMETableBig, { fs: "b:MK0300", mt: 10, txt: "基本汇率", link: "gridlist.html#forex_basic" }),
        react_1.default.createElement(WH_HOMETableBig, { fs: "b:MK0301", mt: 10, txt: "交叉汇率", link: "gridlist.html#forex_cross" })));
}
exports.PageWHSC = PageWHSC;
/**
 * 外汇市场四分卫子元素
 * @param props
 * @returns
 */
function LayoutItem(props) {
    return (react_1.default.createElement(layout_1.Layout4.Item, null,
        react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: props.code, height: 170, width: 242, link: true, border: false }, props.txt)));
}
/**
 * 人民币中间价/人民币即期混合（下线）
 * @returns
 */
function WH_Tabbox() {
    return (react_1.default.createElement("div", { className: "tab_box" },
        react_1.default.createElement(tab2_1.Tab2, { boxdata: [
                {
                    tab_html: react_1.default.createElement("span", { className: "tit" }, "\u4EBA\u6C11\u5E01\u4E2D\u95F4\u4EF7"),
                    more: react_1.default.createElement("a", { href: "gridlist.html#forex_cnyc" }, "\u66F4\u591A>>"),
                    body: react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: 'b:MK0002',
                            count: 5,
                            table_key: 'WHSC',
                            order: '',
                            orderdur: 1 })),
                    bottom: react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
                        react_1.default.createElement("a", { href: "gridlist.html#forex_cnyc" }, "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u4EBA\u6C11\u5E01\u4E2D\u95F4\u4EF7>>"))
                },
                // {
                //   tab_html: <span className="tit">人民币即期混合</span>,
                //   more: <a href="gridlist.html#forex_cnyi">更多&gt;&gt;</a>,
                //   body: <div className="">
                //     <QuoteTableMiddle {...{
                //       fs: 'm:121+t:1',
                //       count: 5,
                //       table_key: 'WHSC',
                //       order: 'f3',
                //       orderdur: 1
                //     }}></QuoteTableMiddle>
                //   </div>,
                //   bottom: <QuoteTableMiddleMore>
                //     <a href="gridlist.html#forex_cnyi">点击查看全部人民币询价&gt;&gt;</a>
                //   </QuoteTableMiddleMore>
                // }
            ] })));
}
/**
 * 外汇首页大表
 * @param props
 * @returns
 */
function WH_HOMETableBig(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(title_1.Title1, { mt: props.mt },
            react_1.default.createElement(title_1.Title1.Main, null, props.txt),
            react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>"))),
        react_1.default.createElement(middle_1.QuoteTableMiddle, { fs: props.fs,
            count: 5,
            table_key: 'WHSC',
            order: 'f3',
            orderdur: 1 }),
        react_1.default.createElement(middle_1.QuoteTableMiddleMore, null,
            react_1.default.createElement("a", { href: props.link },
                "\u70B9\u51FB\u67E5\u770B\u5168\u90E8",
                props.txt,
                ">>"))));
}
